import type { AppStore } from '@/store/appStore';

/** Why each export is unavailable; `null` means it can be produced now. */
export interface ExportAvailability {
  /** Transformed coordinates (PNEZD CSV). */
  csv: string | null;
  /** Analysis log and printed report. */
  report: string | null;
}

/**
 * Final exports require current results: the log and report need a current
 * solution; the coordinate file also needs output generated from it.
 */
export const selectExportAvailability = (
  state: Pick<
    AppStore,
    'solution' | 'solutionStale' | 'transformedPoints' | 'transformedStale'
  >
): ExportAvailability => {
  const solved = !!state.solution && !state.solution.error;
  const report = !solved
    ? 'Solve in Adjust first'
    : state.solutionStale
      ? 'Solution is outdated; re-solve first'
      : null;
  const csv =
    report ??
    (state.transformedPoints.length === 0
      ? 'Transform points on the Export step first'
      : state.transformedStale
        ? 'Output is outdated; transform again'
        : null);
  return { csv, report };
};
